const passwordRequirements = [
  {
    id: 'length',
    label: 'At least 8 characters',
    validate: (password) => password.length >= 8
  },
  {
    id: 'number',
    label: 'Contains at least 1 number',
    validate: (password) => /\d/.test(password)
  },
  {
    id: 'special',
    label: 'Contains at least 1 special character',
    validate: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password)
  },
  {
    id: 'uppercase',
    label: 'Contains at least 1 uppercase letter',
    validate: (password) => /[A-Z]/.test(password)
  },
  {
    id: 'lowercase',
    label: 'Contains at least 1 lowercase letter',
    validate: (password) => /[a-z]/.test(password)
  }
];

export const validatePassword = (password) => {
  return passwordRequirements.map(requirement => ({
    ...requirement,
    meets: requirement.validate(password)
  }));
};

export const isPasswordValid = (password) => {
  return passwordRequirements.every(requirement => requirement.validate(password));
}; 